module.exports = __webpack_public_path__ + "img/xm07-f8575b.png";